<template>
    <div class="guide-tab-wrap" :style="{background: info.normalBg}">
        <ul class="tab-ul m-0-a">
            <li class="d-i-b t-a-c" v-for="(item,index) in info.tab" :key='index' @click="chooseBar(item,index)" :style="activeNum == index ? setActiveBg : setNormalBg">
                {{item.title}}
            </li>
        </ul>
    </div>
</template>
<style scoped lang='less'>
    .guide-tab-wrap {
        width: 100%;
    }
    .tab-ul {
        width: 10rem;
        color: #333333;
        li {
            width: 10/6rem;
            height: 1.066667rem;
            line-height: 1.066667rem;
            cursor: pointer;
            border-right: 1px solid #fff;
            border-bottom: 1px solid #fff;
        }
    }
    @media screen and (min-width:1025px) {
        [pc="1"] .tab-ul {
            font-size: 0;
            li {
                font-size: 18px;
            }
        }
    }
</style>
<script>
    export default {
        props: ['info','gameCode','fontInfo'],
        data() {
            return {
                activeNum: 0
            }
        },
        computed: {
            setActiveBg() {
                if(this.gameCode == 'smsgz'){
                   return 'width:' + 100 / this.info.tab.length + '%;color:#fff;background:' + this.fontInfo.activeColor;
                }else if(this.gameCode == 'sect'){
                   return 'width:' + 100 / this.info.tab.length * 2 + '%;color:#fff;background:' + this.fontInfo.activeColor;
                }
            },
            setNormalBg() {
                if(this.gameCode == 'smsgz'){
                   return 'width:' + 100 / this.info.tab.length + '%;color:#1c3450;background:' + this.fontInfo.normalColor;
                }else if(this.gameCode == 'sect'){
                   return 'width:' + 100 / this.info.tab.length * 2+ '%;color:#1c3450;background:' + this.fontInfo.normalColor;
                }
            }
        },
        methods: {
            chooseBar(_info, _index) {
                this.activeNum = _index;
                this.$emit("chooseBar", _info)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// client/smsgz/components/guide/guide-tab.vue